import { HTMLProps } from "react";

import './style.scss';

interface IProps extends HTMLProps<HTMLInputElement> {}

const Radio = (props: IProps) => (
  <label className="B-betslip-radio">
    <input type="checkbox" {...props} />
    <span className="B-radio-content" />
  </label>
);

export default Radio;